// src/utils/errors/AppError.ts
export class AppError extends Error {
  constructor(
    message: string,
    public statusCode?: number,
    public details?: unknown
  ) {
    super(message);
    this.name = 'AppError';
  }

  static isAppError(error: unknown): error is AppError {
    return error instanceof AppError;
  }
}

export class ApiError extends AppError {
  constructor(
    message: string,
    statusCode?: number,
    details?: unknown
  ) {
    super(message, statusCode, details);
    this.name = 'ApiError';
  }
}
